import { convertQueryObjToString } from "utils"
import parentApi from "store/parentApi"
import { dateTimeFunction } from "utils/date"
import marketingCallRecordingTransformHelper from "./marketingCallRecordingTransformer"
import { callTranscriptionTransformer } from "./callTranscriptionTransformer"
import lmsLeadsTransformer from "features/lms-leads/leads/apis/lmsLeadsTransformer"

const marketingCallRecordingApi = parentApi.injectEndpoints({
  endpoints: build => ({
    getMarketingCallRecords: build.query({
      query: ({ callType, fromDate, toDate, orderBy, ...params }) => {
        const param = { ...params }
        if (!!param.staffFilter) {
          let childIdentifierKey = "staffList_withoutChildren"
          param.staffFilter = encodeURIComponent(
            `{"userIds":[${decodeURIComponent(param.staffFilter)}],"includeAllChildren":${!params?.[
              childIdentifierKey
            ]}}`
          )
        }
        if (toDate && fromDate) {
          param["dateRange"] = encodeURIComponent(
            `{"from":"${dateTimeFunction({
              date: fromDate,
              timeZone: true,
              apiRequest: true,
            })}","to":"${dateTimeFunction({
              date: toDate,
              timeZone: true,
              apiRequest: true,
            })}"}`
          )
        }
        if (orderBy) {
          param["sortOrder"] = orderBy
        }
        delete param["staffList_withoutChildren"]
        return `/externalInquiries/phoneCallReport?${convertQueryObjToString({
          ...param,
          ...(callType !== "all" && callType && { callType }),
        })}`
      },
      transformResponse: response => marketingCallRecordingTransformHelper(response),
    }),

    getMKTGLeadCallLogs: build.query({
      query: params => {
        const { id, callType, ...param } = params
        return `/externalInquiries/${id}/phoneCalls${
          !!params
            ? `?${convertQueryObjToString({
                ...param,
                ...(callType !== "all" && callType && { callType }),
              })}`
            : ""
        }`
      },
      transformResponse: response => marketingCallRecordingTransformHelper(response),
    }),

    getMktgCallTags: build.query({
      query: () => `phoneCalls/callTags?externalPhoneCallsTagFilter=true`,
      transformResponse: response => response.map(e => ({ ...e, value: e.id + "", label: e.title })),
    }),

    getCallTranscription: build.query({
      query: id => `/externalInquiries/phoneCalls/${id}/transcription`,
      transformResponse: response => callTranscriptionTransformer(response),
    }),

    getMktgLead: build.query({
      query: id => `/externalInquiries/${id}`,
      transformResponse: response => lmsLeadsTransformer(response),
    }),
  }),
})
export const {
  useLazyGetMarketingCallRecordsQuery,
  useGetMarketingCallRecordsQuery,
  useLazyGetMktgCallTagsQuery,
  useGetMKTGLeadCallLogsQuery,
  useLazyGetMKTGLeadCallLogsQuery,
  useGetCallTranscriptionQuery,
  useLazyGetCallTranscriptionQuery,
  useGetMktgLeadQuery,
  useLazyGetMktgLeadQuery,
} = marketingCallRecordingApi
